<apcam-country-select
    [label]="inputConfig.label"
    [formcontrolName]="formcontrolName"
    [countryList]="countryList" />
